<template>
  <div>
    <el-row style="margin-bottom: 20px">
      <el-col>
        <span class="label">快递公司：</span><el-input v-model="compName" size="mini" class="txt"></el-input>
        <span class="label">模板名称：</span><el-input v-model="tempName" size="mini" class="txt"></el-input>
        <el-button  type="primary" size="mini" @click="getTemp">查询</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-bottom: 20px">
      <el-col>
        <el-button size="mini" plain type="primary" style="margin-right: 10px; " @click="back2Print">返回打单</el-button>
        <el-button  type="primary" size="mini" @click="showTemp=true; ">添加新模板</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table  :data="tempData" border style="font-size: 12px"
                   :header-cell-style="{ background:'#F2F6FC',color:'#000'}" >
          <el-table-column  label="模板名称" width="160px">
            <template slot-scope="scope">
              <span style="font-size: 12pt;">{{scope.row.tempName}}</span>
              <div><el-button size="mini" type="text" @click="openUpdate(scope.row)">修改</el-button>
                <el-button size="mini" type="text" @click="deleteTemp(scope.row)">删除</el-button></div>
            </template>
          </el-table-column>

          <el-table-column  prop="stdName" label="所属菜鸟云模板" width="120px"></el-table-column>

          <el-table-column v-if="false" label="宽 / 高(mm)" width="120px">
            <template slot-scope="scope">
              <div><span class="label">宽：{{scope.row.width}}</span></div>
              <div><span class="label">高：{{scope.row.height}}</span></div>
            </template>
          </el-table-column>

          <el-table-column  label="电子面单信息" >
            <template slot-scope="scope">
              <div><span class="label">面单来源：</span>
                  <span v-if="scope.row.billSource==''">本店铺</span>{{scope.row.billSource}}

              </div>
              <div><span class="label">网点信息：{{scope.row.branchName}}</span></div>
              <div><span class="label">发货仓库：{{scope.row.sendAddress}}</span></div>
              <el-button size="mini"  type="primary" @click="openMd(scope.row)">设置电子面单</el-button>
              <div style="height: 10px"></div>
            </template>
          </el-table-column>
          <el-table-column  label="打印机-发货地址" width="340px">
            <template slot-scope="scope">
              <div><span class="label">面单打印机：</span> <!-- &#8195-->
                <span v-if="scope.row.printer==''">默认打印机</span>{{scope.row.printer}}
                <el-button size="mini"  type="text" @click="openPrinter(scope.row,1)">设置打印机</el-button>
              </div>
              <div><span class="label">出货单打印机：</span>
                <span v-if="scope.row.outPrinter==''">默认打印机</span>{{scope.row.outPrinter}}
                <el-button size="mini"  type="text" @click="openPrinter(scope.row, 2)">设置打印机</el-button>
              </div>
              <div><span class="label">发货地址：</span>
                <span v-if="scope.row.contactId==''">未设置</span>{{scope.row.defAddress}}
                <el-button size="mini"  type="text" @click="openAddress(scope.row)">设置默认地址</el-button>
              </div>

            </template>
          </el-table-column>

          <el-table-column  label="编辑" width="150px">
            <template slot-scope="scope">
              <div><el-button size="mini"  type="primary" @click="openDesign(scope.row)">编辑自定义区</el-button></div>
            </template>
          </el-table-column>
          <el-table-column  label="显示顺序" width="160px">
            <template slot-scope="scope">
              <div> <el-input-number size="mini" :min="1" :max="50" v-model="scope.row.showId" style="width: 90px"></el-input-number>
                <el-button size="mini"  type="text" @click="updateShowId(scope.row)">保存</el-button></div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog title="添加快递单模板" :visible.sync="showTemp" :close-on-click-modal="false" width="800px" center>
      <div style=" width: 700px; height: 132mm">
        <div style="float: left; margin:0 0 0 30px;">
          <el-input v-model="addStdName" style="width: 240px;" size="mini" @input="getStdTemp" placeholder="快递模板" ></el-input>
          <el-button type="primary" size="mini"  @click="getStdTemp" >搜索</el-button>
          <div  style="display:block; height: 450px; width: 300px;  margin-top: 20px;">
            <el-table :height=450 ref="singleTable" :data="stdTempList" :show-header="false" highlight-current-row
                      @current-change="handleCurrentChange" >

              <el-table-column  label="名称" >
                <template slot-scope="scope">
                  <div style=" margin-top: 10px; margin-left: 10px; ">{{scope.row.templateName}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div style="float: left; width: 76mm; height: 135mm; margin:0 0 0 30px; border:1px #000 solid;">
          <el-image :src='imgUrl' alt="无图片"></el-image>
        </div>
      </div>
      <el-row style="margin-left: 30px; margin-top: 30px">
        <el-col>
          <span calss="label">模板名称：</span><el-input v-model="newTemp" size="mini" type="primary" style="width: 500px;" aria-placeholder="名称"></el-input>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showTemp = false">取 消</el-button>
        <el-button type="primary" @click="saveTemp">保存模板</el-button>
      </span>
    </el-dialog>

    <el-dialog title="设置电子面单信息" :visible.sync="showMd" :close-on-click-modal="false"  width="700px" center>
      <div style=" width: 600px; height: 300px; margin-left: 50px;">
        <el-row style="margin-top: 20px;">
          <el-col>
            <span calss="label">单号来源：</span>
            <el-radio-group v-model="shopName" size="small" @change="getAccountTb">
              <el-radio label="" border style="margin-right: 5px;">本店铺</el-radio>
              <el-radio v-for="sp in shopBands" :label="sp.bindNick" :key="sp.bindNick" border style="margin-right: 10px;" >{{sp.bindNick}}</el-radio>
            </el-radio-group>
            <el-button size="mini" type="success" @click="getAccountTb">同步网点信息</el-button>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px;">
          <el-col>
            <span calss="label">网点信息：</span>
            <el-radio-group v-model="branchName" size="small">
              <el-radio v-for="sp in branchs" :label="sp.branchName+'_'+sp.branchCode + '_' + sp.segmentCode" :key="sp.branchCode" border style="margin-right: 10px;" @change="branchChange(sp)">
                {{sp.branchName}}_{{sp.branchCode}}_余额：{{sp.quantity}}</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px;">
          <el-col>
            <div style="float:left; width: 75px">发货地址：</div>
            <div style="float:left; width: 400px;">
              <el-radio-group v-model="sendAddr" size="small" @change="changeSendAddr">
                <el-radio v-for="addr in sendAddrs" :label="addr" :key="addr" style="width:400px; margin-top: 5px; margin-bottom: 15px;">
                  {{addr}}</el-radio>
              </el-radio-group>
            </div>
          </el-col>
        </el-row>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveMd">保存面单信息</el-button>
        <el-button @click="showMd = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="设置打印机"  :close-on-click-modal="false" :visible.sync="showPrint"  width="500px" center>
      <div style=" width: 600px;  margin-left: 50px;">
        <el-row style="margin-top: 20px;">
          <el-col>
            <span calss="label">打印机列表：</span>
            <el-select id="plist" v-model="printName" size="small" style="width: 300px" placeholder="请选择">
              <el-option  v-for="item in printerList" :key="item.name" :label="item.name" :value="item.name"> </el-option>
            </el-select>
          </el-col>
        </el-row>
        <!--<el-row style="margin-top: 20px;">
          <el-col>
            <span calss="label">打印机偏移：</span>
            左：<el-input v-model="offsetX" size="mini" style="width: 50px"></el-input>毫米，
            上：<el-input v-model="offsetY" size="mini" style="width: 50px"></el-input>毫米
          </el-col>
        </el-row>-->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savePrinter">锁定打印机</el-button>
        <el-button @click="showPrint = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择模板发货地址" :visible.sync="showAddress" :close-on-click-modal="false" width="800px" center>


      <div style="margin-top: 20px;">
        <el-row style="margin-top: 20px;">
          <el-col>
            <span calss="label">单号来源：</span>
            <el-radio-group v-model="shopName" size="small" disabled >
              <el-radio label="" border style="margin-right: 5px;">本店铺</el-radio>
              <el-radio v-for="sp in shopBands" :label="sp.bindNick" :key="sp.bindNick" border style="margin-right: 10px;">{{sp.bindNick}}</el-radio>
            </el-radio-group>

            <el-button type="primary" size="small" @click="getSellerAddress('0')">恢复默认地址</el-button>
            <el-button type="primary" size="small" @click="getSellerAddress('1')">同步淘宝地址库</el-button>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px;">
          <el-col>
            <el-radio-group v-model="sendId">
              <el-radio size="small" v-for="opt in address" :key="opt.contactId" :label="opt.contactId" style="width:600px; margin-bottom: 10px">{{opt.addr}}</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>

      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveAddress">确 定</el-button>
         <el-button @click="showAddress = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改模板名称" :visible.sync="showUpdate" :close-on-click-modal="false" width="400px" center>
      <el-row style="margin-left: 30px; margin-top: 30px">
        <el-col>
          <span calss="label">模板名称：</span><el-input v-model="newTemp" size="mini" type="primary" style="width: 200px;" aria-placeholder="名称"></el-input>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
          <el-button @click="showUpdate = false">取 消</el-button>
          <el-button type="primary" @click="updateTemp">保存</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

    export default {
      name: "KddTemp",
      data(){
        return{
          socket:'',
          //当前行在数据库中的Id
          id:'',
          //查询时参数
          compName:'',
          tempName:'',
          //{showId:2, tempName:'中通一联',kdName:'中通', width:'76', height:'130', billSource:'wgaofa',address:'河南省 郑州市 经开区 中心广场', ck:'武汉',printer:'HP M125-126A',}
          tempData:[],
          showTemp: false,
          cpCode:'',
          kdName:'',
          //标准模板
          stdId:'',
          stdName:'',
          stdUrl:'',
          stdType: '',
          //用户模板名称
          newTemp:'',
          //添加模板时，搜索快递名称
          addStdName:'',
          //{title:'中通',code:'ZTO'},{title:'圆通',code:'YTO'},{title:'申通',code:'STO'},{title:'韵达',code:'YUNDA'}
          kdList:[],
          showUpdate:false,
          stdTempList:[
            // {templateId:1,templateName:'中通一联',standardWaybillType:6,templateUrl:'http://cloudprint.cainiao.com/template/standard/300336/43'},
            // {templateId:2,templateName:'圆通一联',standardWaybillType:6,templateUrl:'http://cloudprint.cainiao.com/template/standard/290659/50'},
            // {templateId:3,templateName:'申通一联',standardWaybillType:6,templateUrl:'http://cloudprint.cainiao.com/template/standard/288948/54'},
            // {templateId:4,templateName:'申通二联',standardWaybillType:6,templateUrl:'http://cloudprint.cainiao.com/template/standard/201/214'},
            // {templateId:5,templateName:'申通蓝牙',standardWaybillType:6,templateUrl:'http://cloudprint.cainiao.com/template/standard/300002/18'},
            // {templateId:6,templateName:'德邦一联',standardWaybillType:6,templateUrl:'http://cloudprint.cainiao.com/template/standard/293905/24'},
            // {templateId:7,templateName:'顺丰丰网-76*130',standardWaybillType:6,templateUrl:'http://cloudprint.cainiao.com/template/standard/490207/6'}
          ],


          currentRow: null,
          //预览图片地址
          imgUrl:'',
          showMd: false,
          shopName:'',
          shopBands:[],
          //默认发货地址
          showAddress: false,
          address:[],
          sendId:'',
          //CP网点信息
          branchs:[],
          //网点名称
          branchName:'',
          branchNames:[],
          //面单发货地址
          province:'',
          city:'',
          district:'',
          detail:'',
          sendAddr:'',
          sendAddrs:[],
          showPrint:false,
          printerList:[],
          //打印机标志
          printIndex:1,
          //面单
          printName:'',
          //出货单
          outPrintName:'',
          offsetX: '0',
          offsetY: '0',
        }
      },
      methods:{
        setCurrent(row) {
          this.$refs.singleTable.setCurrentRow(row);
        },
        back2Print:function () {
          this.$router.replace({name:'Print'})
        },
        handleCurrentChange(val) {
          this.currentRow = val;
          this.cpCode = val.cpCode;
          this.stdId = val.templateId;
          this.stdUrl = val.templateUrl;
          this.stdName = val.templateName;
          this.stdType = val.standardWaybillType;
          //获取纸张大小
          this.print('preview');
        },
        openTemp:function(){
          this.cpCode='',
          this.stdId='';
          this.stdName='';
          this.stdUrl='';
          this.stdType='';
          this.showTemp = true;
        },
        openUpdate(row){
          this.id = row.id;
          this.newTemp = row.tempName;
          this.showUpdate = true;
        },
        updateTemp(){
          let param={
            id: this.id,
            tempName: this.newTemp,
          }
          $api.post('/setup/updateTemp', param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.getTemp();
              this.$message.success('修改名称成功！');
              this.showUpdate = false;
            }else{
              this.$message.error(dataResult.data);
            }
          })
        },
        //更换快递公司  添加快递单模板时，输入名称，查找模板
        getStdTemp:function(){
          this.stdId='';
          this.stdName='';
          this.stdUrl='';
          this.stdType='';
          this.imgUrl='';
          let param={
            stdName: this.addStdName
          }
          $api.post('/cn/getStd', param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.stdTempList = dataResult.data;
            }
          })
        },


        //保存快递单模板
        saveTemp:function(){
          if(this.newId == ''){
            this.$message.error('请先选择模板所属类型！');
            return;
          }
          if(this.newTemp.trim() == ''){
            this.$message.error('请输入模板名称！');
            return;
          }
          let width = 76;
          let height = 130;
          let param={
            nick: storage.get('nick'),
            tempName:this.newTemp,
            cpCode: this.cpCode,
            stdId: this.stdId,
            stdName: this.stdName,
            stdUrl: this.stdUrl,
            width: width,
            height: height
          }
          $api.post("/setup/addTemp", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.getTemp();
              this.showTemp = false;
              this.$message.warning('添加快递单模板成功，请设置电子面单信息！');
            }else{
              this.$message.error(dataResult.message);
            }
          })

        },
        //打开面单信息
        openMd:function(row){
          this.cpCode = row.cpCode;
          this.shopName = row.billSource;
          this.branchName = row.branchName;
          this.sendAddr = row.sendAddress;

          this.id = row.id;
          this.showMd = true;
          //从数据库取网点信息
          this.getAccount(row);
        },
        //取网点信息  DB
        getAccount:function(row){
          let billSource = this.shopName;
          if (this.shopName=='')
            billSource = storage.get('nick');
          let param={
            nick: billSource,
            cpCode: this.cpCode,
          }
          $api.post("/cn/wbAccount", param, response=> {
            let dataResult = response.data;
            console.log(dataResult);
            if (dataResult.state == 1) {
              //组装网点信息
              this.branchs = dataResult.data.branch;
              //默认显示选中设置过的网点信息

              let hasDef = false;
              for (let i = 0; i < this.branchs.length; i++) {
                let brch = this.branchs[i];
                for (let j = 0; j < brch.shippAddressCols.length; j++) {
                  let addr1 = brch.shippAddressCols[j];
                  let addr = brch.shippAddressCols[j].province + ' ' + brch.shippAddressCols[j].city + ' '
                    + brch.shippAddressCols[j].district + ' ' + brch.shippAddressCols[j].detail;
                  if (this.sendAddr == addr) {
                    this.branchChange(this.branchs[i], row);
                    hasDef = true;
                    return;
                  }
                }
              }
              //没有默认网点
              if (!hasDef && (this.branchs.length>0))
                this.branchChange(this.branchs[0], row);
            }
          })
        },
        //获取电子面单余额
        getAccountTb:function(row){
          this.branchName = '';
          this.sendAddrs = [];
          this.sendAddr = '';
          let shop = this.shopName;
          let billSource = this.shopName;
          if (this.shopName=='')
            billSource = storage.get('nick');
          let param={
            //nick: storage.get('nick'),
            nick: billSource,
            cpCode: this.cpCode,
          }
          $api.post("/cn/wbAccountTb", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              //组装网点信息
              this.branchs = dataResult.data.branch;
              //组装网点信息
              this.branchs = dataResult.data.branch;
              //默认显示选中设置过的网点信息
              let hasDef = false;
              for (let i = 0; i < this.branchs.length; i++) {
                let brch = this.branchs[i];
                for (let j = 0; j < brch.shippAddressCols.length; j++) {
                  let addr1 = brch.shippAddressCols[j];
                  let addr = brch.shippAddressCols[j].province + ' ' + brch.shippAddressCols[j].city + ' '
                    + brch.shippAddressCols[j].district + ' ' + brch.shippAddressCols[j].detail;
                  if (this.sendAddr == addr) {
                    this.branchChange(this.branchs[i], row);
                    hasDef = true;
                    return;
                  }
                }
              }
              //没有默认网点
              if (!hasDef && (this.branchs.length>0))
                this.branchChange(this.branchs[0], row);
              this.getSellerAddress('0')
            }
          })
          console.log('eeee:'+ this.shopName);
          this.shopName = shop;
        },
        //网点列表变化
        branchChange:function(branch, row){
          this.detail ='';
          let bn = branch.branchName + '_' + branch.branchCode + '_' + branch.segmentCode;
          this.branchName = bn;
          this.sendAddrs = [];
          let hasDef=false;
          for(let m=0;m<branch.shippAddressCols.length;m++){
            let addr = branch.shippAddressCols[m];
            let str = branch.shippAddressCols[m].province + ' ' + branch.shippAddressCols[m].city + ' ' +  branch.shippAddressCols[m].district + ' ' +  branch.shippAddressCols[m].detail;
            this.sendAddrs.push(str);

          }
        },
        //改变发货仓库
        changeSendAddr(){
          if(this.sendAddr == '' ) {
            this.province = '';
            this.city = '';
            this.district = '';
            this.detail = '';
          }else {
            let addr = this.sendAddr.split(' ');
            this.province = addr[0];
            this.city = addr[1];
            this.district = addr[2];
            this.detail = addr[3];
            for (let i = 4; i < addr.length; i++) {
              this.detail = this.detail + ' ' + addr[i];
            }
          }
        },
        //保存电子面单信息
        saveMd:function(){
          this.changeSendAddr();
          if(this.sendAddr != '') {
            if (this.detail == '') {
              this.$message.error('请选择网点的发货地址！');
              return;
            }
          }
          let param = {
            id: this.id,
            billSource: this.shopName,
            branchName: this.branchName,
            sendAddr: this.sendAddr,
            province: this.province,
            city: this.city,
            district: this.district,
            detail: this.detail
          }
          $api.post("/setup/updateMd", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.getTemp();
              this.showMd =false;
              this.$message.warning('保存电子面单信息成功，请设置默认发货地址！');
            }else{
              this.$message.error('保存电子面单信息失败！')
            }
          })
        },
        //打开打印机窗口
        openPrinter: function(row, idx){
          //idx 1 面单  2 出货单
          this.printIndex = idx;
          this.showPrint = true;
          this.getPrint();
          this.printName = row.printer;
          this.offsetX = row.offsetX;
          this.offsetY = row.offsetY;
          this.id = row.id;
        },
        //保存打印机信息
        savePrinter:function(){
          if(this.printName == "默认打印机")
            this.printName = '';
          let param = {
            id: this.id,
            printIndex: this.printIndex,
            printer: this.printName,
            offsetX: this.offsetX,
            offsetY: this.offsetY
          }
          $api.post("/setup/updatePrinter", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.showPrint=false;
              this.getTemp();
              this.$message.warning('保存打印机信息成功！');
            }else{
              this.$message.error('保存打印机信息失败！')
            }
          })
        },
        //打开地址库
        openAddress: function(row){
          console.log(row.contactId);
          this.sendId = row.contactId;
          this.showAddress = true;
          this.id = row.id;
          this.getSellerAddress('0');
        },
        //取后地址库  0数据库 1 淘宝
        getSellerAddress:function(val){
          let shop = this.shopName;
          let billSource = this.shopName;
          if (this.shopName=='')
            billSource = storage.get('nick');
          let param={
            //nick:storage.get("nick"),
            nick: billSource,
            fromTb: val
          }
          $api.post("/wlb/getAddressList", param, response =>{
            let dataResult = response.data;
            console.log(dataResult);
            if (dataResult.state == 1 && dataResult.message == "ok"){
              this.address = dataResult.data.list;
              //如果模板里没设置默认地址，则默认用卖家默认发货地址
              if(this.sendId == '')
                this.sendId = dataResult.data.sendId;
            }
          })
          this.shopName = shop;
        },
        //保存选中的地址到用户模板中
        saveAddress:function(){
          let param={
            id: this.id,
            contactId: this.sendId
          }
          $api.post("/setup/updateContactId", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              this.$message.success("设置卖家发货地址成功，请编辑自定义打印内容！");
              this.showAddress = false;
              this.getTemp();

            }else{
              this.$message.error(dataResult.data.message);
            }
          })
        },

        //打开编辑区
        openDesign:function(row){
          console.log(row.tempName);
          let stdType = 6;
          if(row.stdName.indexOf('标准模板')>=0 )
            stdType = 1;
          else
            stdType = 6;
          this.$router.push({name: "Design", params:{ id: row.id, tempName: row.tempName, stdType: stdType}});
        },
        //获取用户模板
        getTemp: function(){
          let param ={
            nick:storage.get('nick'),
            tempName: this.tempName,
            compName: this.compName
          }
          $api.post("/setup/getTemp", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              this.tempData = dataResult.data;
            }
          })
        },
        //删除打印模板
        deleteTemp:function(row){
          this.$confirm('确实要删除快递单模板吗?', '提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'success'
          }).then(() => {
            let param={
              id: row.id
            }
            $api.post("setup/deleteTemp", param, response=>{
                let dataResult = response.data;
                if(dataResult.state == 1){
                  this.getTemp();
                  this.$message.success("删除快递单模板成功！");
                }else{
                  this.$message.error(dataResult.data.message);
                }
            })
          })
        },
        //更新显示顺序
        updateShowId:function (row) {
          let param={
            id: row.id,
            showId: row.showId,
          }
          $api.post("setup/updateShowId", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.getTemp();
              this.$message.success("更新显示顺序成功！");
            }else{
              this.$message.error(dataResult.data.message);
            }
          })
        },


        //连接WebSocket
        connect:function(){
          let  serverUrl='wss://localhost:13529';
          if(typeof(WebSocket) === "undefined"){
            alert("您的浏览器不支持socket")
          }else{
            // 实例化socket
            this.socket = new WebSocket(serverUrl);
            // 监听socket连接
            this.socket.onopen = this.open;
            // 监听socket错误信息
            this.socket.onerror = this.error;
            // 监听socket消息
            this.socket.onmessage = this.getMessage;
          }
        },
        open: function () {
          console.log("socket连接成功");
          this.getPrint();
        },
        error: function () {
          console.log("连接错误")
        },
        getMessage: function (obj) {
          console.log(obj.data);
          let data = JSON.parse(obj.data);
          if (data.cmd == "getPrinters") {
            this.printerList = data.printers;
            let p = new Object();
            p.name = '默认打印机';
            this.printerList.push(p);
            this.printName = data.defaultPrinter;
            this.outPrintName = data.defaultPrinter;
          }else if (data.cmd == "getPrinterConfig") {
            alert(obj.data);
          }
          if (data.previewImage) {
            this.imgUrl = data.previewImage;
            console.log(this.imgUrl)
            this.showPreview=true;
          }
        },
        getRequestObject: function (cmd) {
          let request = new Object();
          let time = new Date().getTime();
          request.requestID=time.toString();
          request.version="1.0";
          request.cmd=cmd;
          return request;
        },
        //打印机列表
        getPrint: function () {
          let request = this.getRequestObject("getPrinters");
          this.socket.send(JSON.stringify(request));
        },
        //预览
        print:function (value) {
          let request = this.getRequestObject("print");
          request.task = new Object();
          request.task.taskID = request.requestID + "_TASK_0";
          if (value == "preview") {
            request.task.preview = true;
            request.task.previewType = "image";
          } else {
            request.task.preview = false;
          }
          request.task.printer = this.printName;
          let documents = new Array();
          for(let i=0;i<1;i++){
            let row = this.currentRow;
            console.log(row.templateUrl);

            let doc = new Object();
            doc.documentID = i;
            let contents = new Array();
            let content = new Object();
            content.templateURL = row.templateUrl; //"http://cloudprint.cainiao.com/template/standard/288948/54";
            content.signature='';
            let trade = new Object();

            content.data = this.getTempTestObject();
            contents.push(content);
            doc.contents = contents;
            documents.push(doc);
            if (value == "preview")
              break;
          }
          request.task.documents = documents;
          console.log(JSON.stringify(request))
          this.socket.send(JSON.stringify(request));
        },
        //生成测试数据
        getTempTestObject: function () {
          let data = new Object();
          data.waybillCode = '0123456789';

          let recipient = new Object();
          recipient.mobile = '13012345678';
          recipient.name='菜鸟网络';
          recipient.phone = '057112345678';
          let recvdAddr = new Object();
          recvdAddr.city='杭州市';
          recvdAddr.detail='良睦路999号乐佳国际大厦2号楼小邮局';
          recvdAddr.district='余杭区';
          recvdAddr.province='浙江省';
          recvdAddr.town='';
          recipient.address=recvdAddr;
          data.recipient = recipient;

          let sender = new Object();
          let sendAddr = new Object();
          sendAddr.city='杭州市';
          sendAddr.detail='文一西路1001号阿里巴巴淘宝城5号小邮局';
          sendAddr.district='余杭区';
          sendAddr.province='浙江省';
          sendAddr.town='';
          sender.address = sendAddr;
          sender.mobile = '13012345678';
          sender.name='阿里巴巴';
          sender.phone = '057112345678';
          sender.address = sendAddr;
          data.sender = sender;

          let routingInfo = new Object();
          let consolidation = new Object();
          consolidation.name = '杭州';
          consolidation.code ='hangzhou';
          let origin = new Object();
          origin.name='杭州';
          origin.code='POSTB';
          let sortation = new Object();
          sortation.name='杭州';
          routingInfo.consolidation= consolidation;
          routingInfo.origin=origin;
          routingInfo.sortation=sortation;
          routingInfo.routeCode='123A-456-789';

          data.routingInfo=routingInfo;

          return data;

        },
        getShopBind: function(){

          let param={
            nick: storage.get("nick"),
            subNick:storage.get("subnick")
          }
          $api.post("/getShop", param,response=> {
            console.log(response.data)
            let dataResult = response.data;
            if (dataResult.state == "1" && dataResult.message == "ok") {
              this.shopBands = dataResult.data
            } else {
              this.$message.error(dataResult.message);
            }
          })
          /*let nick = storage.get("nick");
          let obj = {};
          obj.nick= nick;
          obj.bindNick = nick;
          this.shopBands.splice(0, 0, obj);*/
        },
      },
      mounted(){
        //快递模板
        this.getTemp();
        //绑定的店铺
        this.getShopBind();

        //连接打印机
        this.connect();
        //
        this.getStdTemp();
        //
        //this.getSellerAddress('0');

      }
    }
</script>

<style scoped>
  .label{
    font-size:12px;
    margin-left: 5px;
  }
  .txt{
    width: 120px;
    margin-right: 5px;
  }

  .scell{
    border: solid 0px #8cc5ff;
    padding: 10px 10px;
  }

/*  .el-table .cell {
    white-space:normal;
    word-break:break-word;
    color: #000000;
    padding: 10px 10px 10px 10px;

  }
  .el-table{
    border: solid 1px #cccccc;
  }
  .el-table td{
    border: solid 0px #8cc5ff;

    padding: 10px 10px;
  }

  td {
    border: solid 0px #8cc5ff;
  }*/

</style>



// WEBPACK FOOTER //
// src/print/KddTemp.vue